import { Link } from '@web/app/components'
import { authActions, logoutUser } from '@web/app/features/auth'
import type { AccessResource } from '@web/types'
import { Button, View, ViewProps } from '@kit/ui' // Eliminado Popover y Popover.Close
import { LogOut } from '@tamagui/lucide-icons'
import { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { accessSelectors } from '../store'

interface ResourceContentProps extends ViewProps {
  id: AccessResource['id']
}

export function ResourceContent({ id }: ResourceContentProps) {
  if (id === '/') {
    return <HomeResourceContent />
  }
  return <ResourceContentPopper id={id} />
}

function HomeResourceContent() {
  const dispatch = useDispatch()

  async function handleLogout() {
    dispatch(logoutUser())
    dispatch(authActions.logout())
  }

  return (
    <View py="$2">
      {/* Eliminado Popover.Close porque ya no estamos en un Popover */}
      <Button
        jc="flex-start"
        px="$2"
        size="$3" // Un poco más grande para sidebar
        chromeless // Quita el fondo del botón para que parezca link
        icon={<LogOut color="white" />} // Icono blanco
        onPress={handleLogout}
      >
        <Button.Text color="white">Cerrar sesión</Button.Text>
      </Button>
    </View>
  )
}

interface ResourceContentPopperProps {
  id: AccessResource['id']
}

const ResourceContentPopper = memo(({ id }: ResourceContentPopperProps) => {
  const level2Links = useSelector(accessSelectors.level2Links)
  const level2LinksForResource = level2Links.filter((link) => link.parentRouteId === id)

  if (level2LinksForResource.length === 0) {
    return null
  }
  return (
    <View gap="$2" py="$1">
      {level2LinksForResource.map((link) => (
        // Eliminado Popover.Close
        <Link
          key={link.id}
          id={link.id}
          to={link.to}
          grid
          textTransform="capitalize"
          replace
          // --- AQUÍ ESTÁ EL ARREGLO VISUAL ---
          color="blue"
          style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 1
          }}
        // -----------------------------------
        >
          {link.text}
        </Link>
      ))}
    </View>
  )
})